import * as React from 'react';
import Tab from '@mui/material/Tab';
import LowMarginLowVolume from './Charts/Pricing/LowMarginLowVolume';
import BelowMinimumThreshold from './Charts/Pricing/BelowMinimumThreshold';
import ProfitEatingAccounts from './Charts/Pricing/ProfitEatingAccounts';
import ChartTabs from '../../Common/ChartTabs';
import GP from './Charts/Pricing/GP';

export default function Pricing({ height }: { height: number }) {
  return (
    <ChartTabs 
      tabs={[
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Low Margin Low Volume" value="1" />,
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Orders Below Minimum Threshold" value="2" />,
        // <Tab wrapped style={{ textTransform: 'capitalize' }} label="Price Mode" value="3" />,
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Profit Eating Accounts" value="3" />,
        <Tab wrapped style={{ textTransform: 'capitalize' }} label="Gross Profit" value="4" />
      ]}
      values={["1", "2", "3", "4"]} 
      ariaLabel="pricing tabs" 
      panels={[
        <LowMarginLowVolume title="Low Margin Low Volume" height={height} />,
        <BelowMinimumThreshold title="Orders Below Minimum Threshold" height={height} />,
        // <PriceMode title="Price Mode" />,
        <ProfitEatingAccounts title="Profit Eating Accounts" height={height} />,
        <GP title="Gross Profit" height={height} />
      ]}
    />
    
  );
}
